export var MuiLink = {
    defaultProps: { underline: 'none', variant: 'body1' },
    styleOverrides: {
        root: {
            fontWeight: 500,
            cursor: 'pointer',
        },
    },
};
